import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/investments.css';
import mamitoIMG from "../images/mamito.jpeg";
import girlieIMG from "../images/girlie.jpeg";
import broIMG from "../images/bro.jpeg";
import bros from "../images/st-1.png";
import useInView from "../lib/useInView";
import LocationMap from '../components/LocationMap';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../lib/firebase';
import { FaArrowRight } from 'react-icons/fa';
import { investmentPlans } from '../lib/plans';
import HeroSection from '../components/HeroSection';


const Investments = ({ user }) => {
    const navigate = useNavigate();

    // handle account balance logic needed for trade
    useEffect(() => {
        const fetchAccountBalances = async () => {
            if (user?.uid) {
                try {
                    const userDoc = await getDoc(doc(db, 'bit', user.uid));
                    if (userDoc.exists()) {
                    }
                } catch (error) {
                    console.error("Error fetching account balances:", error);
                }
            }
        };

        fetchAccountBalances();
    }, [user]);


    // inView Hook used to handle animations
    const [box7Ref, box7InView] = useInView({ threshold: 0.7 });
    const [box8Ref, box8InView] = useInView({ threshold: 0.7 });
    const [box9Ref, box9InView] = useInView({ threshold: 0.7 });



    return (
        <div className="transaction-container" id="investments">
            <HeroSection />

            {/* next after hero section */}
            <div className="last-section how-it-works">
                <div className="box">
                    <h2 className="text-heading">
                        Who we are?
                    </h2>
                    <div className="box-text centered">
                        <p>
                            <strong>Diamond FXTL Trades</strong> is a global financial services firm offering expert research,
                            investment strategies, and advisory solutions. With years of combined experience,
                            we help clients outperform markets across diverse asset classes.

                            <ul>
                                <li><strong>Global Equities & Indices</strong> (NYSE, SGX, and other major exchanges)</li>
                                <li><strong>Forex (FX)</strong> trading across major and exotic currency pairs</li>
                                <li><strong>Cryptocurrencies</strong>, from leading tokens to emerging digital assets</li>
                                <li><strong>CFDs</strong> (Contracts for Difference) on 6,000+ instruments</li>
                                <li><strong>Commodities</strong>, including <em>agriculture, natural stones, and precious metals</em></li>
                                <li><strong>Fixed Income</strong>, such as <em>bonds and debt instruments</em></li>
                                <li><strong>Physical assets</strong>, including select <em>tangible investment-grade goods</em></li>
                            </ul>

                            With a commitment to innovation, accuracy, and performance, Market Power Finance is your trusted partner for navigating the
                            dynamic landscape of global investing.
                        </p>
                    </div>
                    <button
                        onClick={() => navigate("/login")}
                        className="delete-button cta-btn">
                        Start Staking   <FaArrowRight />
                    </button>
                </div>
                <div className="box">
                    <img src={bros}
                        className="boxed-images"
                        alt="RELOCATING AND SCHOOLING IN THE U.S."
                    />
                </div>
            </div>

            {/* section for traders */}
            <div className="last-section how-it-works">
                <div className="box">
                    <h2 className="handwriting">
                        For traders
                    </h2>
                    <h2 className="text-heading">
                        It doesn't take a thing to build that sustainable income with us.
                    </h2>
                </div>
                <div className="box">
                    <ul className='features-list'>
                        <li className="box-text">
                            <strong>Choose a package:</strong> Choose any of our investment packages and grow steadily with it.
                        </li>
                        <li className="box-text">
                            <strong>Make payment:</strong> Fund your account using Bitcoin, Bitcoin cash or Perfect Money.
                        </li>
                        <li className="box-text">
                            <strong>Trade begins:</strong> With out team of expert traders, we delight you with our daily trades.
                        </li>
                    </ul>

                </div>
            </div>


            {/* Investment Plans */}
            <div className={user?.uid ? "investing-plans" : "investment-plans"}>
                <div className="plans">
                    {investmentPlans.map((plan, index) => (
                        <div className="plan" key={index}>
                            <img src={plan.image} alt="" className='invest-plan-image' />
                            <h2 className="text-heading">{plan.name}</h2>
                            <div className="plan-specs">
                                <div className="spec-row">
                                    <span>{plan.tps}</span>
                                </div>
                                <div className="spec-row">
                                    <span>Duration:</span>
                                    <strong>{plan.durationDisplay}</strong>
                                </div>
                                <div className="spec-row">
                                    <span>Requirement:</span>
                                    <strong>{plan.price}</strong>
                                </div>
                                <div className="spec-row">
                                    <span>Assets:</span>
                                    <strong>{plan.chains}</strong>
                                </div>
                                <div className="spec-row">
                                    <span>ROI:</span>
                                    <strong>{plan.profit}% Guaranteed</strong>
                                </div>
                            </div>

                            <button
                                className={`select-btn ${user ? 'logged-in' : ''}`}
                                onClick={() => {
                                    if (user) {
                                        navigate('/node');
                                    } else {
                                        navigate('/login');
                                    }
                                }}
                            >
                                {user ? 'Start Investing' : 'Get Started'}
                            </button>
                        </div>
                    ))}
                </div>
            </div>


            {/* Location Map for Servers */}
            <div className="server-coverage-section">
                <h2 className="text-heading">
                    Global Server Infrastructure
                </h2>
                <p className="box-description">
                    We operate high-performance data centers with dedicated validation servers across 22 strategic locations worldwide,
                    ensuring low-latency access and maximum uptime for all investors.
                </p>
                <div className='mob-map'>
                    <LocationMap />
                </div>
            </div>
            <div className="last-section how-it-works">
                <div className="box box-map">
                    <LocationMap />
                </div>
                <div className="box">
                    <div className="trust-section">
                        <h2 className="trust-title">PEOPLE TRUST US</h2>
                        <div className="stats-container">
                            <div className="stat-item">
                                <p className="stat-description">Global Users</p>
                                <p className="stat-number">453K</p>
                            </div>
                            <div className="stat-item">
                                <p className="stat-description">Enterprises</p>
                                <p className="stat-number">60+</p>
                            </div>
                            <div className="stat-item">
                                <p className="stat-description">Unique Addresses</p>
                                <p className="stat-number">127 N Elizabeth St, Lima, Ohio 45801</p>
                            </div>
                        </div>
                    </div>

                </div>
            </div>




            {/* The last page content */}
            <div className="main-box-cover">
                <h2 className="text-heading centered">
                    Giving Back – <span>Building Futures.</span>
                </h2>
                <div className="box-text centered">
                    At Market Power Finance, our mission goes beyond financial returns — we are deeply committed to creating lasting social impact.
                    Through our charitable initiatives and NGO partnerships, we support vulnerable families, underfunded communities, and crisis-affected countries around the world.
                    From funding education and healthcare to providing food, shelter, and emergency aid, we believe that giving back is not just a responsibility — it’s who we are.
                </div>
            </div>


            <div className="last-section">
                <div className="box">
                    <div
                        ref={box9Ref}
                        className={`icon-title-text-container animate__animated ${box9InView ? "animate__zoomInRight" : ""}`}
                    >
                        <img
                            src={girlieIMG}
                            className="boxed-icon"
                            alt="GLOBAL HUMANITARIAN OUTREACH"
                        />
                        <div className="title-text">
                            <h2 className="box-title">
                                GLOBAL HUMANITARIAN OUTREACH
                            </h2>
                            <div className="box-text">
                                We actively collaborate with communities and organizations around the world to support crisis relief, provide food, education, and healthcare, and deliver hope where it's needed most.
                            </div>
                        </div>
                    </div>
                    <h2 className="text-heading centered">
                        Navigate complexity with a trusted capital markets services partner — and a heart for humanity.
                    </h2>
                    <a href="/charity" className="cta-button">
                        Learn More About Our Charity Work
                    </a>
                </div>

                <div className="box">
                    <div
                        ref={box7Ref}
                        className={`icon-title-text-container animate__animated ${box7InView ? "animate__zoomInRight" : ""}`}
                    >
                        <img
                            src={mamitoIMG}
                            className="boxed-icon"
                            alt="ECONOMIC EMPOWERMENT INITIATIVES"
                        />
                        <div className="title-text">
                            <h2 className="box-title">
                                ECONOMIC EMPOWERMENT INITIATIVES
                            </h2>
                            <div className="box-text">
                                We invest in people by supporting small businesses, vocational training, and financial education—empowering individuals and families to build sustainable futures.
                            </div>
                        </div>
                    </div>

                    <div
                        ref={box8Ref}
                        className={`icon-title-text-container animate__animated ${box8InView ? "animate__zoomInRight" : ""}`}
                    >
                        <img
                            src={broIMG}
                            className="boxed-icon"
                            alt="EDUCATION & RESETTLEMENT SUPPORT"
                        />
                        <div className="title-text">
                            <h2 className="box-title">
                                EDUCATION & RESETTLEMENT SUPPORT
                            </h2>
                            <div className="box-text">
                                From scholarships to relocation assistance, we help students and displaced families access quality education and stable environments to restart and thrive.
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    );
};

export default Investments;
